import { useForm } from "react-hook-form"
import IconButton from "../../../common/IconButton"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { updateProfile } from "../../../../service/operation/Profile";


export default function EditProfile() {
    const {user} = useSelector((state) => state.profile);
    const {token} = useSelector((state) => state.auth);
    const genders = ["Male", "Female", "Non-Binary", "Prefer not to say", "Other"]
    const {
        register,
        handleSubmit,
        formState:{errors},

    } = useForm()
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleForm = async(data) => {
     const profileData = {
      ...data,
      userId:user._id
     }

     await updateProfile(token,profileData,navigate,dispatch)
    }
 
  return (
    <>
      <form onSubmit={handleSubmit(handleForm)}>
        {/* Profile Information */}
        <div className="my-10 flex flex-col gap-y-6 rounded-md border-[1px] border-richblack-700 bg-richblack-800 p-8 px-12">
          <h2 className="text-lg font-semibold text-richblack-5">
            Profile Information
          </h2>
          <div className="flex flex-col gap-5 lg:flex-row">
            <div className="flex flex-col gap-2 lg:w-[48%]">
              <label htmlFor="firstName" className="lable-style">
                First Name
              </label>
              <input
                type="text"
                name="firstName"
                id="firstName"
                placeholder="Enter first name"
                className="form-style"
                defaultValue={user?.firstName}
                {...register("firstName",{required:true})}
              />
              {errors.firstName && (
                <span className="-mt-1 text-[12px] text-yellow-100">
                  Please enter your first name.
                </span>
              )}

            </div>
            <div className="flex flex-col gap-2 lg:w-[48%]">
              <label htmlFor="lastName" className="lable-style">
                Last Name
              </label>
              <input
                type="text"
                name="lastName"
                id="lastName"
                placeholder="Enter first name"
                className="form-style"
                defaultValue={user?.lastName}
                {...register("lastName",{required:true})}
              />
              {errors.lastName && (
                <span className="-mt-1 text-[12px] text-yellow-100">
                  Please enter your last name.
                </span>
              )}
            </div>
          </div>

          <div className="flex flex-col gap-5 lg:flex-row">
            <div className="flex flex-col gap-2 lg:w-[48%]">
              <label htmlFor="dateOfBirth" className="lable-style">
                Date of Birth
              </label>
              <input
                type="date"
                name="dateOfBirth"
                id="dateOfBirth"
                className="form-style"
                defaultValue={user?.additionalDetails?.dateOfBirth}
                {...register("dateOfBirth",{required:true})}
              />
              {errors.dateOfBirth && (
                <span className="-mt-1 text-[12px] text-yellow-100">
                 Enter Date Of Birth
                </span>
              )}
            </div>
            <div className="flex flex-col gap-2 lg:w-[48%]">
              <label htmlFor="gender" className="lable-style">
                Gender
              </label>
              <select
                type="text"
                name="gender"
                id="gender"
                className="form-style"
                defaultValue={user?.additionalDetails?.gender}
                {...register("gender",{required:true})}
              >
                {genders.map((ele, i) => {
                  return (
                    <option key={i} value={ele}>
                      {ele}
                    </option>
                  )
                })}
              </select>
              {errors.gender && (
                <span className="-mt-1 text-[12px] text-yellow-100">
                  Select You Gender
                </span>
              )}
            </div>
          </div>

          <div className="flex flex-col gap-5 lg:flex-row">
            <div className="flex flex-col gap-2 lg:w-[48%]">
              <label htmlFor="contactNumber" className="lable-style">
                Contact Number
              </label>
              <input
                type="tel"
                name="contactNumber"
                id="contactNumber"
                placeholder="Enter Contact Number"
                className="form-style"
                defaultValue={user?.additionalDetails?.contactNumber}
                {...register("contactNumber",{
                  required:{value:true,message:"Phone Number Is Required"},
                  minLength:{value:10,message:"Invallied Phone Number"},
                  maxLength:{value:12,message:"Invallied Phone Number"}
                })}
                />
              {errors.contactNumber && (
                <span className="-mt-1 text-[12px] text-yellow-100">
                  {errors.contactNumber.message}
                </span>
              )}
            </div>
            <div className="flex flex-col gap-2 lg:w-[48%]">
              <label htmlFor="about" className="lable-style">
                About
              </label>
              <input
                type="text"
                name="about"
                id="about"
                placeholder="Enter Bio Details"
                className="form-style"
                defaultValue={user?.additionalDetails?.about}
                {...register("about",{required:true})}
              />
              {errors.about && (
                <span className="-mt-1 text-[12px] text-yellow-100">
                  Please enter your About.
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-2">
          <button
            onClick={() => {
              navigate("/dashboard/my-profile")
            }}
            className="cursor-pointer rounded-md bg-richblack-700 py-2 px-5 font-semibold text-richblack-50"
          >
            Cancel
          </button>
          <IconButton type="submit" text="Save" active={true}/>
        </div>
      </form>
    </>
  )
}
